module.exports = ".list {\r\n    padding-bottom: 1px;\r\n}\r\n\r\n.qr-wrapper {\r\n    padding-top: 15px;\r\n    font-size: 1.9em;\r\n    color: #0057a9;\r\n}\r\n\r\n.qr-wrapper i {\r\n    color: #00a0eb;\r\n}\r\n\r\n.qr-wrapper span {\r\n    margin-left: -7px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/client-app/login-token/login-token.component.css
// module id = ./src/app/client-app/login-token/login-token.component.css
// module chunks = main